import clsx from 'clsx';
import { makeStyles } from '@bymason-private/controller-v1-theme-provider';

interface ControllerLogoProps {
  collapse: boolean;
}

const useStyles = makeStyles((theme) => ({
  logo: {
    alignSelf: 'center',
    marginTop: theme.spacing(1.5),
    minHeight: 31,
    width: 144,
  },
  logoCollapse: {
    marginBottom: theme.spacing(0.25),
    marginTop: theme.spacing(2),
    width: 20,
  },
}));

export default function ControllerLogo({ collapse }: ControllerLogoProps) {
  const classes = useStyles();

  return (
    <>
      {!collapse && (
        <img
          className={classes.logo}
          src='https://mcdn.bymason.com/v1/controller/logo/modern--grayscale_full.svg'
        />
      )}
      {collapse && (
        <img
          className={clsx(classes.logo, classes.logoCollapse)}
          src='https://mcdn.bymason.com/v1/controller/logo/modern--grayscale_icon-only.svg'
        />
      )}
    </>
  );
}
